module.exports = __webpack_public_path__ + "static/media/mexican.509d4790.jpg";